import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PendingTasksTable from './PendingTasksTable';

export default withTranslation('pages')(
  withRouter(PendingTasksTable),
);
